export enum InvoiceDeliveryMethod {
  EInvoiceB2C = 1,
  EmailWithPDF = 2,
  Manual = 3,
  Mail = 4,
  Sms = 5,
  EInvoiceB2B = 6,
  EmailWithoutPDF = 7,
  Avy = 9,
  NoDelivery = 10,
  Kivra = 11,
}
export enum DebtCollectionCompany {
  RopoCapital = 3,
  RopoOne = 14,
  Preventia = 16,
  Profina = 17,
  PsFinanceGroup = 21,
  FastighetsagarnaMittNord = 22,
}

export enum AmortizationPlanStatus {
  Draft = 0,
  Approved = 1,
  Completed = 2,
  Cancelled = 3,
}

export enum ReminderDeliveryMethod {
  None = 0,
  Email = 2,
  Manual = 3,
  Mail = 4,
}

export enum PaymentNoticeDeliveryStatus {
  Pending = 0,
  Processing = 1,
  Retrying = 2,
  Sent = 3,
  Failed = 4,
}

export enum InvoiceStatus {
  NotAttested,
  Attested = 1,
  InProcess = 2,
}

export enum InvoiceAttestStatus {
  NotRequested = 1,
  Pending = 2,
  Completed = 10,
  Failed = 99,
}

export enum InvoiceType {
  Credit = 1,
  General = 2,
  Rent = 3,
  Fee = 4,
}

export enum InvoiceRowType {
  Normal = 0,
  Information = 2,
}

export enum LeaseAgreementInformationRowContentKind {
  LeaseAgreement = 0,
  RentalId = 1,
  NoRentalId = 2,
  PeriodAddressRentalId = 3,
  PeriodAddress = 4,
}

const UNIT_ERROR = 'Invalid entry unit.';

export function LeaseAgreementInformationRowContentKindToString(informationKind: LeaseAgreementInformationRowContentKind) {
  switch (informationKind) {
    case LeaseAgreementInformationRowContentKind.LeaseAgreement:
      return 'CONST.INFORMATION_ROW_LEASE_AGREEMENT_NUMBER';

    case LeaseAgreementInformationRowContentKind.RentalId:
      return 'CONST.INFORMATION_ROW_RENTAL_ID';

    case LeaseAgreementInformationRowContentKind.NoRentalId:
      return 'CONST.INFORMATION_ROW_NO_RENTAL_ID';

    case LeaseAgreementInformationRowContentKind.PeriodAddressRentalId:
      return 'CONST.INFORMATION_ROW_PERIOD_ADDRESS_RENTAL_ID';

    case LeaseAgreementInformationRowContentKind.PeriodAddress:
      return 'CONST.INFORMATION_ROW_PERIOD_ADDRESS';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export function GetInvoiceDeliveryMethodIcon(method: InvoiceDeliveryMethod): string {
  switch (method) {
    case InvoiceDeliveryMethod.Kivra:
      return 'assets/icons/kivra-logo.svg';
    case InvoiceDeliveryMethod.EInvoiceB2C:
      return 'assets/icons/einvoice.svg';
    case InvoiceDeliveryMethod.EmailWithPDF:
      return 'pdf';
    case InvoiceDeliveryMethod.EmailWithoutPDF:
      return 'email';
    case InvoiceDeliveryMethod.Mail:
      return 'mail';
    case InvoiceDeliveryMethod.Manual:
      return 'print';
    case InvoiceDeliveryMethod.Sms:
      return 'sms';
    case InvoiceDeliveryMethod.EInvoiceB2B:
      return 'assets/icons/einvoice-company.svg';
    case InvoiceDeliveryMethod.Avy:
      return 'assets/icons/avy1-logo.svg';
    case InvoiceDeliveryMethod.NoDelivery:
    default:
      return undefined;
  }
}

export function InvoiceDeliveryMethodToString(method: InvoiceDeliveryMethod) {
  switch (method) {
    case InvoiceDeliveryMethod.Kivra:
      return 'CONST.INVOICE_DELIVERY_KIVRA';

    case InvoiceDeliveryMethod.EInvoiceB2C:
      return 'CONST.INVOICE_DELIVERY_METHOD_EINVOICE';

    case InvoiceDeliveryMethod.EmailWithPDF:
      return 'CONST.INVOICE_DELIVERY_METHOD_EMAIL_WITH_PDF';

    case InvoiceDeliveryMethod.EmailWithoutPDF:
      return 'CONST.INVOICE_DELIVERY_METHOD_EMAIL_WITHOUT_PDF';

    case InvoiceDeliveryMethod.Mail:
      return 'CONST.INVOICE_DELIVERY_METHOD_MAIL';

    case InvoiceDeliveryMethod.Manual:
      return 'CONST.INVOICE_DELIVERY_METHOD_MANUAL';

    case InvoiceDeliveryMethod.Sms:
      return 'CONST.INVOICE_DELIVERY_METHOD_SMS';

    case InvoiceDeliveryMethod.EInvoiceB2B:
      return 'CONST.INVOICE_DELIVERY_METHOD_EINVOICE_B2B';

    case InvoiceDeliveryMethod.Avy:
      return 'CONST.INVOICE_DELIVERY_METHOD_AVY';

    case InvoiceDeliveryMethod.NoDelivery:
      return 'CONST.INVOICE_DELIVERY_METHOD_NO_DELIVERY';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export function DebtCollectionCompanyToString(debtCompany: DebtCollectionCompany) {
  switch (debtCompany) {
    case DebtCollectionCompany.RopoCapital:
      return 'COMPANY.DBC_TRANSFER.ROPONOVA';

    case DebtCollectionCompany.RopoOne:
      return 'COMPANY.DBC_TRANSFER.ROPOONE';

    case DebtCollectionCompany.Preventia:
      return 'COMPANY.DEBT_COLLECTION.PREVENTIA';

    case DebtCollectionCompany.Profina:
      return 'COMPANY.DEBT_COLLECTION.PROFINA';

    case DebtCollectionCompany.PsFinanceGroup:
      return 'COMPANY.DEBT_COLLECTION.PSFINANCEGROUP';

    case DebtCollectionCompany.FastighetsagarnaMittNord:
      return 'COMPANY.DEBT_COLLECTION.FASTIGHETSAGARNA_MITTNORD_INKASSO';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export function AmortizationPlanStatusToString(status: AmortizationPlanStatus) {
  switch (status) {
    case AmortizationPlanStatus.Draft:
      return 'AMORTIZATION_PLAN.STATUS_DRAFT';

    case AmortizationPlanStatus.Approved:
      return 'AMORTIZATION_PLAN.STATUS_APPROVED';

    case AmortizationPlanStatus.Completed:
      return 'AMORTIZATION_PLAN.STATUS_COMPLETED';

    case AmortizationPlanStatus.Cancelled:
      return 'AMORTIZATION_PLAN.STATUS_CANCELLED';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export function ReminderDeliveryMethodToString(method: ReminderDeliveryMethod) {
  switch (method) {
    case ReminderDeliveryMethod.None:
      return 'CONST.INVOICE_DELIVERY_METHOD_NO_DELIVERY';

    case ReminderDeliveryMethod.Email:
      return 'CONST.INVOICE_DELIVERY_METHOD_EMAIL_WITHOUT_PDF';

    case ReminderDeliveryMethod.Mail:
      return 'CONST.INVOICE_DELIVERY_METHOD_MAIL';

    case ReminderDeliveryMethod.Manual:
      return 'CONST.INVOICE_DELIVERY_METHOD_MANUAL';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export function GetReminderDeliveryMethodIcon(method: ReminderDeliveryMethod): string {
  switch (method) {
    case ReminderDeliveryMethod.Email:
      return 'email';

    case ReminderDeliveryMethod.Mail:
      return 'mail';

    case ReminderDeliveryMethod.Manual:
      return 'print';

    case ReminderDeliveryMethod.None:
    default:
      return undefined;
  }
}

export function PaymentNoticeDeliveryStatusToString(status: PaymentNoticeDeliveryStatus) {
  switch (status) {
    case PaymentNoticeDeliveryStatus.Pending:
      return 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_STATUS_PENDING';

    case PaymentNoticeDeliveryStatus.Processing:
      return 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_STATUS_PROCESSING';

    case PaymentNoticeDeliveryStatus.Retrying:
      return 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_STATUS_RETRYING';

    case PaymentNoticeDeliveryStatus.Sent:
      return 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_STATUS_SENT';

    case PaymentNoticeDeliveryStatus.Failed:
      return 'AMORTIZATION_PLAN.PAYMENT_NOTICE.DELIVERY_STATUS_FAILED';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export function InvoiceStatusToString(status: InvoiceStatus) {
  switch (status) {
    case InvoiceStatus.Attested:
      return 'CONST.INVOICE_STATUS_ATTESTED';

    case InvoiceStatus.NotAttested:
      return 'CONST.INVOICE_STATUS_CREATED';

    case InvoiceStatus.InProcess:
      return 'CONST.INVOICE_STATUS_IN_PROCESS';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export function InvoiceAttestStatusToString(status: InvoiceAttestStatus) {
  switch (status) {
    case InvoiceAttestStatus.Completed:
      return 'CONST.INVOICE_STATUS_ATTESTED';

    case InvoiceAttestStatus.NotRequested:
      return 'CONST.INVOICE_STATUS_CREATED';

    case InvoiceAttestStatus.Pending:
      return 'CONST.INVOICE_STATUS_IN_PROCESS';

    case InvoiceAttestStatus.Failed:
      return 'CONST.INVOICE_STATUS_FAILED';

    default:
      throw new Error(UNIT_ERROR);
  }
}

export function InvoiceTypeToString(invType: InvoiceType) {
  switch (invType) {
    case InvoiceType.Credit:
      return 'CONST.INVOICE_TYPE.CREDIT';

    case InvoiceType.General:
      return 'CONST.INVOICE_TYPE.GENERAL';

    case InvoiceType.Rent:
      return 'CONST.INVOICE_TYPE.RENT';

    case InvoiceType.Fee:
      return 'CONST.INVOICE_TYPE.FEE';

    default:
      throw new Error(UNIT_ERROR);
  }
}
